import React from 'react';
function ClubCard({ ...r }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18" {...r}>
			<path
				fill="#272727"
				fillRule="evenodd"
				d="M18 13H2v3h16v-3zm0-11H2v9h16V2zM1 0h18a1 1 0 011 1v16a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm10.056 4.088a2.872 2.872 0 00-.66 2.903l.096.253.021.045.059.104a.816.816 0 001.462-.678L12 6.614l-.031-.071a1.234 1.234 0 01.19-1.238 1.116 1.116 0 011.127-.386c.376.091.682.374.816.75l.037.129a.816.816 0 001.592-.369 2.79 2.79 0 00-2.165-2.126 2.743 2.743 0 00-2.509.785z"
				clipRule="evenodd"
			></path>
		</svg>
	);
}

export default ClubCard;
